import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import { env } from 'config/env';
import { Colors } from 'styles';

type Props = {
  loading: boolean;
  hasData: boolean;
  overrideLinearProgress?: boolean;
};

const TableLoading = ({
  loading,
  hasData,
  overrideLinearProgress = false,
}: Props): React.ReactElement | null => {
  const isStoryshots = env.STORYBOOK_STORYSHOTS === 'true';

  if (!loading) {
    return null;
  }

  if (hasData && !overrideLinearProgress) {
    return <LinearProgress css="position: relative; margin-bottom: -1px; height: 1px;" />;
  }

  return (
    <div
      data-testid="table-loading"
      css={`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: ${Colors.gray1};
        z-index: 1;
        padding-top: 50px;
        text-align: center;
      `}
    >
      {isStoryshots ? <CircularProgress variant="determinate" value={75} /> : <CircularProgress />}
    </div>
  );
};

export default TableLoading;
